import './App.css';
import Herosection from './components/herosection/Herosection';
import Tools from './components/tools/Tools';
import Terms from './components/terms/Terms';
import Transactions from './components/transactions/Transactions';
import Choose from './components/choose/Choose';
import Security from './components/security/Security';
import Solutions from './components/solutions/Solutions';
import Popular from './components/popular/Popular';
import Faqs from './components/faqs/Faqs';
// import Footer from './components/footer2/Footer';
import Footerlast from './components/footer/Footer';
import Footerwallet from './components/footerwallet/Footer';
function App() {
  return (
    <div className="App">
   <Herosection/>
   <Transactions/>
   <Terms/>
   <Tools/>
   <Choose/>
   <Security/>
   <Solutions/>
   <Popular/>
   <Faqs/>
   {/* <Footer/> */}
   <Footerwallet/>
   <Footerlast/>
    </div>
  );
}

export default App;
